export default "__VITE_ASSET__De1oHjob__"